/* This file includes everything to be included in the webpack build */
import "./js/AspectFit";
import "./js/AudioAnalysis.js";
import "./js/AudioPlayer.ts";
import "./js/AudioRecording.js";
import "./js/ClickOutside.js";
import "./js/DeviceServices.js";
import "./js/ElementObserver.js";
import "./js/FfmpegInterop.ts";
import "./js/LocalFileStore.ts";
import "./js/PopUp.ts";
import "./js/ScreenSizeObserver.ts"
import "./js/ScrollHandler.js";
import "./js/TimelineDragScroll.js";
import "./js/SubmissionsBuffer"
import "./js/Transition";
import "./js/Utils.js";
import "./js/VideoPlayer";
import "./js/VideoPlayer360";

(window as any).appJsLoaded = true;
